import React from 'react';
import ReactDOM from 'react-dom';

import { Home } from '@home/components';

const HomeContent = {
  start: function(params) {
    ReactDOM.render(
      <Home sections={ params.sections } hideCtas={ params.hideCtas } />, 
      document.getElementById('home-content')
    )
  }
};

window.HomeContent = HomeContent;
